import React, {ReactNode} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {ApiServiceProvider} from "../context/ApiServiceContext";

interface MainRouterProps {
    children: ReactNode
}

const MainRouter: React.FC<MainRouterProps> = ({children}) => {

    return (
        <Router>
            <ApiServiceProvider>
                {children}
            </ApiServiceProvider>
        </Router>
    );
};

export default MainRouter;